export default {
  'pages.ledger.adminTitle': '記帳管理',
  'pages.ledger.consoleTitle': '我的記帳',
  'pages.ledger.adminDesc': '查看與管理全部使用者的記帳流水，支援按使用者 / 類型 / 類目 / 時間篩選。',
  'pages.ledger.consoleDesc': '管理歸屬當前帳號的記帳流水。',
  'pages.ledger.new': '記一筆',
  'pages.ledger.colUser': '歸屬用戶',
  'pages.ledger.colUserIdFilter': '用戶ID',
  'pages.ledger.userIdPlaceholder': '輸入用戶ID篩選',
  'pages.ledger.colType': '類型',
  'pages.ledger.colAmount': '金額',
  'pages.ledger.colCategory': '類目',
  'pages.ledger.colOccurredAt': '發生時間',
  'pages.ledger.colRemark': '備註',
  'pages.ledger.colCreatedAt': '建立時間',
  'pages.ledger.colTimeRange': '發生時間',
  'pages.ledger.colActions': '操作',
  'pages.ledger.edit': '編輯',
  'pages.ledger.delete': '刪除',
  'pages.ledger.confirmDelete': '確定刪除該條記帳？',
  'pages.ledger.confirm': '確定',
  'pages.ledger.cancel': '取消',
  'pages.ledger.created': '記帳成功',
  'pages.ledger.updated': '更新成功',
  'pages.ledger.deleted': '已刪除',
  'pages.ledger.opFail': '操作失敗',
  'pages.ledger.typeRequired': '請選擇類型',
  'pages.ledger.amountRequired': '請輸入金額',
  'pages.ledger.amountMin': '金額必須大於0',
  'pages.ledger.categoryRequired': '請選擇或輸入類目',
  'pages.ledger.categoryPlaceholder': '選擇或輸入類目',
  'pages.ledger.occurredRequired': '請選擇時間',
  'pages.ledger.remarkPlaceholder': '備註（可選）',
  'pages.ledger.targetUser': '歸屬用戶',
  'pages.ledger.targetUserTip': '留空則歸屬當前登入帳號',
  'pages.ledger.searchUserPlaceholder': '輸入用戶名搜尋選擇',
  'pages.ledger.noUserFound': '未找到用戶',
  'pages.ledger.summaryTitle': '月度匯總',
  'pages.ledger.summaryIncome': '收入',
  'pages.ledger.summaryExpense': '支出',
  'pages.ledger.summaryBalance': '結餘',
  'pages.ledger.summaryMonth': '月份',
  'pages.ledger.summaryCatType': '類型',
  'pages.ledger.summaryCatName': '類目',
  'pages.ledger.summaryCatCount': '筆數',
  'pages.ledger.summaryCatTotal': '小計',
  'pages.ledger.currencyLabel': '記帳幣種',
  'pages.ledger.currencySetFirst': '設定記帳幣種',
  'pages.ledger.currencyChange': '修改記帳幣種',
  'pages.ledger.currencyChangeTip': '修改後，歷史記錄保留原幣種，列表與匯總僅統計新幣種。確定繼續？',
  'pages.ledger.currencySetFirstTip': '首次記帳前需先設定幣種。選擇您日常使用的幣種：',
  'pages.ledger.currencyRequired': '請選擇幣種',
  'pages.ledger.currencySelectPlaceholder': '選擇幣種',
  'pages.ledger.currencySet': '幣種已設定',
  'pages.ledger.type.expense': '支出',
  'pages.ledger.type.income': '收入',
};
